import React from 'react';

import { FormattedMessage as Trans } from 'react-intl';

import { useSeoMetada } from '../hooks/useSeoMetadata';

import Layout from '../components/Layout';
import Header from '../components/Header';
import Section from '../components/Section';
import Author from '../components/Author';
import BlockContent from '../components/BlockContent';

const AuthorContainer = ({ data }) => {
  const { content } = data;
  const {
    seoMetadata: contentfulSeoMetadata,
    firstName,
    lastName,
    bio,
    avatar
  } = content;
  const { edges: articles } = data.articles;
  const { edges: authors } = data.authors;

  const { helmetMetadata } = useSeoMetada(contentfulSeoMetadata, {
    title: `${firstName} ${lastName}`,
    description: bio?.childMarkdownRemark?.rawMarkdownBody,
    ogImage: avatar
  });

  return (
    <Layout data={data} helmetMetadata={helmetMetadata}>
      <Header
        header={{
          blockContent: {
            title: `${firstName} ${lastName}`,
            description: bio
          },
          isNavbarTransparent: true
        }}
      />
      <Section
        section={{
          version: 'articles',
          contentful_id: content?.contentful_id
        }}
        articles={articles}
      />
      <Section
        section={{
          version: 'children'
        }}
      >
        <BlockContent
          content={{
            headingOne: <Trans id="authorPageOtherAuthorsTitle" />
          }}
        />
        <div className="authors">
          {authors?.map((author) => (
            <Author key={author.node.id} author={author.node} />
          ))}
        </div>
      </Section>
    </Layout>
  );
};

export default AuthorContainer;
